import { Component } from '@angular/core';

@Component({
    selector: 'sr-login-expired-page',
    templateUrl: './expired.view.html',
    styleUrls: ['./expired.style.scss'],
    standalone: false
})
export class ExpiredComponent { }